import Vue from 'vue'
import store from './store'
import sitemap from './sitemap'
import Router from 'vue-router'
import markets from './enums/market'

Vue.use(Router)

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: sitemap,
})

router.beforeEach((to, from, next) => {
  const [matched] = to.matched
  const isLoggedIn = store.getters['authentication/isLoggedIn']
  if (matched.meta.requiresAuth && !isLoggedIn) {
    const returnUrl = location.pathname
    next({path: '/login', query: returnUrl != '/' ? {returnUrl} : null})
    return
  }

  if (store.getters['app/pathNamesForCurrentRole'].has(matched.path)) {
    next()
  } else {
    next({path: '/'})
  }
})

router.afterEach(({path, meta}) => {
  store.dispatch('app/addHistory', {path})
  const currentMarketId = store.getters['app/marketId']
  let marketId = -1

  if (meta.module && meta.markets == null) {
    marketId = markets[meta.module]
    store.dispatch('app/setMenuMarket', {marketId})
  } else if (meta.markets && !Object.values(meta.markets).includes(currentMarketId)) {
    //const marketId = Object.values(meta.markets)[0]
    const metaMarkets = Object.values(meta.markets)
    marketId = metaMarkets[0]
    store.dispatch('app/setMenuMarket', {marketId})
  }
})

export default router
